import { HttpMethods, } from './types';
import AxiosClient from './AxiosClient';
export * from './types';
export default class EumApiClient {
    apiConfig;
    axiosClient;
    constructor(userConfig) {
        this.apiConfig = {
            // baseURL: baseUrl,
            timeout: userConfig.timeout,
            ...userConfig,
            requestConfig: {
                ...userConfig.requestConfig,
                headers: {
                    // Authorization: 'Bearer {token}',
                    'X-Requested-With': 'XMLHttpRequest',
                    ...userConfig.requestConfig?.headers,
                },
            },
        };
        this.axiosClient = new AxiosClient(this.apiConfig);
    }
    send(method, option) {
        const { url, data, params, headers } = option || {};
        const invalidatedUrl = this.invalidateUrl(url || '');
        const promise = this.axiosClient
            .send(method, invalidatedUrl, data, params, headers);
        return promise.then((data) => {
            if (data === undefined) {
                debugger;
            }
            /*
           2021-10-20
           단일파일 업로드인경우 (/file/store/flow) Uncaught (in promise) undefined 에러 발생
           예외처리
           return Data {
               contentType: null
               serializerSettings: null
               statusCode: null
               value: {{resultData}}
           }
           */
            if (data.value) {
                return data.value;
            }
            if (data && data.code === 'ok') {
                return data.result;
            }
            else {
                throw (data || {}).error;
            }
        });
    }
    get(option) {
        return this.send(HttpMethods.GET, option);
    }
    delete(option) {
        return this.send(HttpMethods.DELETE, option);
    }
    put(option) {
        return this.send(HttpMethods.PUT, option);
    }
    post(option) {
        return this.send(HttpMethods.POST, option);
    }
    patch(option) {
        return this.send(HttpMethods.PATCH, option);
    }
    invalidateUrl(path) {
        var rootUrl = this.apiConfig.rootUrl;
        var url = '';
        if (path.startsWith('/')) {
            url = rootUrl + path;
        }
        else if (path.startsWith('http://') || path.startsWith('https://')) {
            url = path;
        }
        else {
            url = path;
        }
        return url;
    }
}
//# sourceMappingURL=index.js.map